import { Agency, Calendar, Route, Trip } from "../../parsegenerated";
import { StopConverter } from "./StopConverter";

export class RouteConverter {
  private index: number;
  private id: string;
  private offer: any;
  private offerRoute: any;
  private stopConverter: StopConverter;
  private agency: Agency;
  private route?: Route;
  private trip?: Trip;

  constructor(agency: Agency, offer: any, places: any[], index: number) {
    this.agency = agency;
    this.offer = offer;
    this.index = index;
    this.id = agency.get("agency_id") + "-route-" + index;
    this.offerRoute = offer.get("route") as any;
    this.stopConverter = new StopConverter(offer, places);
    this.init();
  }

  private init() {
    this.createRoute();
    this.assignTripToStopTimes();
  }

  private createRoute() {
    const stopNames = this.stopConverter
      .getStops()
      .map((stop) => stop.get("stop_name"));
    const from = stopNames[0];
    const to = stopNames[stopNames.length - 1];

    this.route = new Route({
      agency_id: this.agency,
      route_id: this.id,
      route_short_name:
        (from?.substring(0, 2) ?? "") + (to?.substring(0, 2) ?? ""),
      route_long_name: [from, to].join(" - "),
      route_desc: this.offerRoute.get("id"),
      route_type: 3,
      route_color: "#000000",
      route_text_color: "#FFFFFF",
    });
  }

  private assignTripToStopTimes() {
    if (!this.route) return;

    this.trip = new Trip({
      route_id: this.route,
      objectId: this.id + "-trip",
      trip_headsign: this.route?.get("route_long_name"),
      trip_short_name: this.route?.get("route_short_name"),
    });

    this.stopConverter
      .getStopTimes()
      .forEach((stopTime) => stopTime.set("trip_id", this.trip!));
  }

  getRoute() {
    return this.route;
  }

  getTrip() {
    return this.trip;
  }

  getStopTimes() {
    return this.stopConverter.getStopTimes();
  }

  getStops() {
    return this.stopConverter.getStops();
  }

  getCalendar() {
    const weekdays = this.offer
      .get("weekdays")
      .map((day: string) => Number.parseInt(day));

    return new Calendar({
      monday: weekdays.includes(1),
      tuesday: weekdays.includes(2),
      wednesday: weekdays.includes(3),
      thursday: weekdays.includes(4),
      friday: weekdays.includes(5),
      saturday: weekdays.includes(6),
      sunday: weekdays.includes(7) || weekdays.includes(0),
    });
  }
}
